export default __webpack_public_path__ + "static/media/janecooper.586240f6.svg";